export default {
  operationFailed: '操作失败',
  errorTip: '错误提示',
  errorMessage: '操作失败,系统异常!',
  timeoutMessage: '登录超时,请重新登录!',
  apiTimeoutMessage: '接口请求超时,请刷新页面重试!',
  networkException: '网络异常',
  networkExceptionMsg: '网请检查您的网络连接是否正常!络异常',

  errMsg401: 'Unauthorized!',
  errMsg403: 'Forbidden!',
  errMsg404: 'Not Found!',
  errMsg405: 'Method Not Allowed!',
  errMsg408: 'Request Timeout!',
  errMsg500: 'Internal Server Error!',
  errMsg501: 'Not Implemented!',
  errMsg502: 'Bad Gateway!',
  errMsg503: 'Service Unavailable!',
  errMsg504: 'Gateway Timeout!',
  errMsg505: 'HTTP Version Not Supported!',
}
